import { ClientLogger } from 'bernie-client';
import AffiliateHubLogger from '../util/affiliate-hub-logger';

const { getLoggerWithIdentifier } = ClientLogger;
const LOGGER = new AffiliateHubLogger(getLoggerWithIdentifier('ui-telemeter'));

class Telemeter {
  public call(event: string) {
    fetch(`/1x1.png?type=${event}`, { method: 'GET' }).catch((err) => {
      LOGGER.error('SEND_FAILED', err);
    });
  }

  public increment(event: string) {
    this.call(event);
  }
}

const telemeter = new Telemeter();

export default telemeter;
